<template>
	<PopOver
		:overlay="false"
		:open="open"
		:placement="placement"
		class="flow-info-popover"
		@click.native="handleClick"
		@mouseover.native="open = true"
		@mouseleave.native="open = false"
	>
		<!-- @slot Used for element on which popover will display -->
		<slot />

		<template #content>
			<div class="info-pop-over-template" :style="{ maxWidth: maxWidth }">
				<div v-if="$slots['header']" class="header">
					<!-- @slot Used to display header with close icon -->
					<slot name="header" />
				</div>

				<div class="body">
					<Container direction="column" :padding="0" :gap="8">
						<!-- @slot Used to display context specific information -->
						<slot name="body" />
					</Container>
				</div>
			</div>
		</template>
	</PopOver>
</template>
<script>
import { defineComponent } from "vue";
import Container from "./../Container/Container.vue";
import PopOver from "./../PopOver/PopOver.vue";

export default defineComponent({
	name: "InfoPopover",
	components: {
		PopOver,
		Container
	},
	props: {
		/**
		 *Trigger Props is used for how you want to trigger the pop over via 'click' | 'hover'
		 **/
		trigger: {
			type: String,
			default: "click hover"
		},
		/**
		 *Placement Props is used for direction of your info pop over
		 *  */
		placement: {
			type: String,
			default: "bottom-start"
		},
		/**
		 * Container props is used to provide a parent element under which info pop over will appended for example ".info-pop-over-render-wrap" | "div.flow-layout"
		 *  */
		container: {
			type: String,
			default: "div.flow-layout"
		},
		/**
		 * auto | any value as string 100px |  200px | 120px
		 *  */
		maxWidth: {
			type: String,
			default: "300px"
		}
	},
	data() {
		return {
			open: false
		};
	},
	computed: {
		isClickTrigger() {
			return this.trigger.indexOf("click") > -1;
		}
	},
	methods: {
		handleClick(e) {
			if (this.isClickTrigger) {
				this.open = true;
			}
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
.info-pop-over-template {
	padding: 12px;
	max-width: 300px;
	background-color: #000;
	border-radius: 4px;
	cursor: default;
	max-height: 90vh;
	overflow-y: auto;

	.header {
		display: flex;
		align-items: flex-start;
		margin-bottom: 8px;

		* {
			margin-bottom: 0;
		}
		> * + *:not(.close-info-pop-over) {
			margin-left: 12px;
			margin-right: 12px;
		}
	}

	*[data-color="dark"] {
		color: white;
	}
}

.flow-info-popover {
	.flow-popover-overlay {
		display: none !important;
	}
}
</style>
